import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";


const listarEncuestas = async ({ token, callbacks }) => {
    const response = await connection({ method: 'GET', url: `${ENTITY_URL.ADMIN.ENCUESTA.LISTAR}`, extraHeaders: { token: token } });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default listarEncuestas;